<div class="text-center">
  <span class="error-code">404</span>
  <h1>This page doesn't exist</h1>
</div>
